import React from "react";
import "./index.scss";
import TextBox from "devextreme-react/text-box";
import { IMdaeTextBoxProps } from "./index";
import { useDispatch } from "react-redux";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { RequiredFieldLabel } from "../required-field-label";

const MdaeTextBox: React.FC<IMdaeTextBoxProps> = (props) => {
  const dispatch = useDispatch();
  return (
    <div className={"sys-mdae-text-box-container"}>
      <TextBox
        {...props}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_TEXT_BOX,
            e.component,
            dispatch
          );
        }}
      ></TextBox>
      {props.visible !== false && (
      <span className={`mdae-text-box-field-set-text ${props.madeFieldTitleClassName}`}>
          {props.mdaeTextBoxTitle}
          {props.required && <RequiredFieldLabel />}
        </span>
      )}
    </div>
  );
};
export default MdaeTextBox;
